<!-- 饼图 -->
<template>
    <div class="width_height_100" :id="id"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
    name: "echartPie",
    data() {
        return {};
    },
    props: {
        id: {
            type: String,
            default: "line",
        },
        data: {
            type: Array,
            default: function () {
                return [{ value: 0, name: "广告" }];
            },
        },
    },
    mounted() {
        this.initPie();
    },
    methods: {
        initPie() {
            let chartDom = document.getElementById(this.id);
            let myChart = echarts.init(chartDom);
            let option;
            option = {
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: ["40%", "70%"],
                        data: this.data,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: "#fff",
                            borderWidth: 2,
                        },
                    },
                ],
            };
            option && myChart.setOption(option);
        },
    },
};
</script>

<style scoped>
.width_height_100 {
    width: 100%;
    height: 100%;
}
</style>